/**
 * Whether a failed query should be shown as an error state.
 *
 * Only when the query is in error AND there is no cached data to show: good cached data is never
 * hidden behind an error, and a query that has not failed (first load, or a successful retry
 * that produced data) never shows the error.
 *
 * What a Retry does to `isError` depends on the query (react-query 4.24.4): a query that already
 * had data keeps `isError` true through the refetch, but a query that NEVER had data resets
 * `error` to null and `status` to 'loading' on refetch, so `isError` goes false and the host
 * stops showing the panel on the first click (it returns if the refetch fails again). Callers
 * must therefore not assume the panel survives a retry; it does not matter to this predicate,
 * which only reads the current state.
 */
export const shouldShowLoadError = (q: { isError: boolean; hasData: boolean }): boolean =>
  q.isError && !q.hasData;
